import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import API_URL from '../config/api';

/**
 * Custom hook to track page visits
 * Automatically tracks visits when the route changes
 */
function usePageTracking() {
  const location = useLocation();
  const { token } = useAuth();

  useEffect(() => {
    // Generate or retrieve session ID
    let sessionId = sessionStorage.getItem('nightfall_session_id');
    if (!sessionId) {
      sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
      sessionStorage.setItem('nightfall_session_id', sessionId);
    }

    // Track the page visit
    const trackVisit = async () => {
      try {
        const pagePath = location.pathname + location.search;
        const referrer = document.referrer || null;

        const headers = {
          'Content-Type': 'application/json',
        };

        // Add auth token if available
        if (token) {
          headers['Authorization'] = `Bearer ${token}`;
        }

        await fetch(`${API_URL}/analytics/track-visit`, {
          method: 'POST',
          headers,
          body: JSON.stringify({
            pagePath,
            referrer,
            sessionId,
          }),
        });
      } catch (error) {
        // Silently fail - don't interrupt user experience
        console.debug('Failed to track visit:', error);
      }
    };

    // Small delay to ensure page is loaded
    const timeoutId = setTimeout(trackVisit, 100);

    return () => clearTimeout(timeoutId);
  }, [location.pathname, location.search, token]);
}

export default usePageTracking;

